import React from 'react'
import GenerateQuestion from '.'
import toast from 'libs/toast'

import useAxios from 'hooks/useAxios'

export default function GenarateQuestionContainer({ surveyToken, questions, setQuestions }) {
  const { fetch: promptFetch, loading } = useAxios({
    url: `survey/survey/${surveyToken}/question-generator/`,
    method: 'post',
    skip: true,
  })

  function submitPrompt(prompt) {
    if (prompt != '' || prompt != undefined) {
      setQuestions([])
      promptFetch({
        data: {
          prompt,
        },
      })
        .then((res) => {
          setQuestions(res.data)
        })
        .catch((err) => {
          toast.error('Something went wrong, please try again.')
          console.error(err.message)
        })
    }
  }

  return (
    <GenerateQuestion
      questions={questions}
      loading={loading}
      submitPrompt={submitPrompt}
      setQuestions={setQuestions}
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/GenerateQuestion/container.js